import { atom } from "jotai";

import React from "react";
import { CurrentUserType, getSessionList } from "./polyfills";
import { CourseListItem, ReceiverType, SimpleSessionItem } from "./types";
import { EventEmitter } from "eventemitter3";
import { getBriefSession, makeSenderFlag } from "./Utils/common";
import moment from "moment";
import { atomWithStorage } from "jotai/utils";

// 用户信息
export const userAtom = atom({
    isStu: (CurrentUserType as string) === ReceiverType.Student,
    userNo: "",
    userName: "",
    senderFlag: makeSenderFlag({
        no: "",
        type: ""
    })
});

// 当前会话
export const curSessionIdAtom = atom<string | undefined>(undefined);

// 当前课程
export const curCourse = atom<CourseListItem | undefined>(undefined);

// 所有会话
export const AllSessionAtom = atom(getSessionList);

// 会话列表(只保存简单信息, 不保存聊天内容)
export const SessionListKeyAtom = atom(Symbol());

export const SessionListAtom = atom<SimpleSessionItem[]>(get => {
    const user = get(userAtom);
    get(SessionListKeyAtom);
    const sessions = get(AllSessionAtom);
    const unreadSessions = get(UnReadSessionsAtom);

    return sessions
        .map(item => {
            const session = getBriefSession(user.senderFlag, item);
            const hasNewMessage =
                session.hasNewMessage || unreadSessions.includes(item.guid);

            return {
                ...session,
                hasNewMessage
            };
        })
        .filter(item => !!item.userNo) // 过滤掉错误数据
        .sort((item1, item2) => {
            return moment(item1.lastSessionTime).isAfter(item2.lastSessionTime)
                ? -1
                : 1;
        });
});

// 有未读消息的会话列表
export const UnReadSessionsAtom = atomWithStorage<string[]>(
    "UnReadSessions",
    []
);

export const ChatEvent = new EventEmitter();

interface ChatCtxProps {
    sendMessage: (val: string) => void;
}

export const ChatContext = React.createContext<ChatCtxProps>({
    sendMessage() {}
});
